module.exports = __webpack_public_path__ + "img/scadenze-standard-emt.0664b21b.png";